export default __webpack_public_path__ + "static/media/train21.20b07b3c.png";